import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import LoginLayout from './layouts/LoginLayout';
import DefaultLayout from './layouts/DefaultLayout';
import { AppRoute, AppRouter } from 'AdminApp/components';
import { connect } from 'react-redux';
import { appMountedAction } from 'AdminApp/logic/store/AppActions';
import { refreshAuthAction } from 'AdminApp/modules/auth/AuthActions';
import ForgotPassword from 'AdminApp/modules/login/ForgotPassword';

// Set chart color
import Chart from 'chart.js';
Chart.defaults.global.defaultFontColor = 'white';
Chart.defaults.global.fullWidth = true;

const mapDispatchToProps = dispatch => {
  return {
    appMounted: () => {
      return dispatch(appMountedAction( ))
    },
    refreshAuth: () => {
      return dispatch(refreshAuthAction());
    },
  }
}

const mapStateToProps = state => {
  return {
    ready: state.ready
  }
}

@connect(mapStateToProps, mapDispatchToProps)
class App extends Component {

  componentDidMount() {
    this.props.appMounted();
    this.props.refreshAuth();
  }

  render() {
    if(!this.props.ready) return null;
    return (
      <AppRouter>
        <div>
          <Switch>
            {/* <AppRoute path="/login/reset-password" component={ForgotPassword} unAuthenticatedOnly/> */}
            <AppRoute path="/login" component={LoginLayout} unAuthenticatedOnly/>
            <AppRoute path="/reset/:hash" component={LoginLayout} unAuthenticatedOnly/>
            <AppRoute path="/" component={DefaultLayout} authenticatedOnly/>
          </Switch>
        </div>
      </AppRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js